import {Strong} from "evergreen-ui";
import React, { Dispatch, useCallback } from 'react';

import { CloseButton } from '../../common';

import { ModalActionPayload } from './action';
import { ModalState } from './state';


type Props = ModalState & {
    dispatch: Dispatch<ModalActionPayload>;
    isPreferred?: boolean;
}

function PreferredStatus () {
    return (
        <Strong
            className='py-1 px-2'
            borderRadius='6px'
            backgroundColor='#F02A2F'
            size={ 300 }
            font="inherit"
            style={ {
                color: '#FFFFFF'
            } }
        >
            Client expressed interest
        </Strong>
    );
}


// ensure modal header display with proper height on Safari
const SAFARI_MIN_HEIGHT = '70px';

export function Modal({ show, title, children, dispatch, isPreferred = false }: Props) {
    const close = useCallback(
        () => dispatch({
            type: 'MODAL_ACTION',
            show: false,
        }),
        [dispatch]
    );

    // for transition animation
    const transformCss = show ? 'translate-x-0 shadow-3xl' : 'translate-x-full';

    return (
        <div className={ `fixed top-0
                ml-auto
                flex flex-col
                inset-0 border-0 rounded-2xl
                overflow-y-scroll scrollbar-always
                z-40
                w-full
                h-screen
                bg-white
                transition-transform duration-300 ease-in-out
                transform
                outline-none focus:outline-none ${ transformCss }` }
             style={ { width: '460px' } }
        >
            <header className="modal-header
                sticky top-0 bg-white
                flex items-start justify-between
                p-5 rounded-t"
                    style={{ minHeight: SAFARI_MIN_HEIGHT }}
            >
                <h3 className='text-xl font-semibold'>
                    { title }
                </h3>

                { isPreferred && <PreferredStatus /> }

                <CloseButton onClick={ close }/>
            </header>

            { children && children }
        </div>
    );
}
